


















import { Component, Prop, Vue } from "vue-property-decorator";
import DatabaseTab from './DatabaseTab.vue';
import MasterListTab from './MasterListTab.vue';
@Component({
  components: {
    DatabaseTab,
    MasterListTab
  },
})
export default class TreatmentDatabase extends Vue {
  tab = 0;
  onChangeTabs() {
  }
}
